// extracted by mini-css-extract-plugin
export var errorsContainer = "_te-1";
export var link = "_te-0";